import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgBug = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16.078 18.005"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m14.978 6.405 1-2c.2-.5 0-1.1-.4-1.3-.5-.2-1.1 0-1.3.4l-.9 1.7-1 .6-.6-.6c-.2 0-.5-.2-.7-.3v-.9c0-.5-.1-.9-.3-1.3l1-1c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-1 1c-.4-.2-.8-.3-1.3-.3-.4 0-.8.1-1.1.2l-1.3-1c-.4-.3-1.1-.3-1.4.2-.3.4-.2 1.1.2 1.4l1 .8c-.3.4-.4.9-.4 1.4v.9c-.2.1-.5.3-.7.5-.5.3-.8.8-1.2 1.3l-.3-.3-.9-1.8c-.3-.5-.9-.7-1.3-.5-.5.3-.7.9-.5 1.3l1 2c0 .1.1.2.2.3l1 1h.1c-.1.4-.1.8-.1 1.2h-1.3c-.6 0-1 .4-1 1s.4 1 1 1h1.2c0 .4.1.8.1 1.2h-.1l-1 1c-.1.1-.1.2-.2.3l-1 2c-.2.5 0 1.1.4 1.3.3.3.4.3.6.3.4 0 .7-.2.9-.6l.9-1.9.3-.3c1.1 1.7 2.9 2.8 4.9 2.8 1.3 0 2.7-.5 3.7-1.4.7-.6 1.2-1.2 1.5-2l.9 1.8c.2.4.5.6.9.6.1 0 .3 0 .4-.1.5-.2.7-.8.4-1.3l-1-2c0-.1-.1-.2-.2-.3l-1-1c0-.4.1-.9.1-1.3h1.3c.6 0 1-.4 1-1s-.4-1-1-1h-1.3v-.2l-.3-1.2 1.2-.8c.1 0 .2-.2.3-.4Zm-7.9-2.4c0-.6.4-1 1-1 .3 0 .5.1.7.3.2.2.3.4.3.7v.1h-.2c-.2-.1-.4-.1-.6-.1h-.3c-.2 0-.5 0-.7.1-.1 0-.2 0-.2-.1Zm4.7 8.9c-.1.9-.6 1.7-1.3 2.2-.7.6-1.5.9-2.4.9-1.8 0-3.4-1.3-3.7-3.1-.1-.6-.1-1.2-.1-1.9s0-1.3.1-1.9c.1-.9.6-1.7 1.3-2.2.3-.2.5-.4.8-.5.8-.4 1.8-.4 2.7-.2.2.1.3.1.5.2.3.1.5.3.8.5.7.6 1.1 1.4 1.3 2.2.1.6.1 1.2.1 1.9s0 1.3-.1 1.9Z"
      fill="#000"
      fillRule="nonzero"
    />
  </svg>
);
const Memo = memo(SvgBug);
export default Memo;
